export const generateCatInit =(type, brandId)=> {
    const catModel = {
        type: "",
        brandId: "",
        catCode: "",
        catName: "",
        responseTime: "",
        fixTime: "",
        responseTimeOutZone: "",
        fixTimeWithCentralOutZone: "",
        fixTimeNoCentralOutZone: "",
        isCentralZone: false
      }
      
    let catList = []
    for (let index = 1; index <= 5; index++) {
      catList.push({ ...catModel, type: type, brandId: brandId, catCode: `CAT${index}`, catName: `CAT ${index}` })
    }
    return catList

}

export const catNameHolder = (catCode)=>{
  const cats ={
    "CAT1": "CAT 1",
    "CAT2": "CAT 2",
    "CAT3": "CAT 3",
    "CAT4": "CAT 4",
    "CAT5": "CAT 5"
  }

  return cats[catCode]
}